import Label from 'reactstrap/lib/Label'
import styled from 'styled-components'

export default styled(Label)`
  font-size: 13px;
  line-height: 26px;
  width: 39px;
`
